<template>
  <div class="card" :class="[type && `card-${type}`]">
    <div class="card-image" v-if="$slots.image"><slot name="image"></slot></div>
    <div
      class="card-header"
      v-if="$slots.header || title"
      :class="headerClasses"
    >
      <slot name="header">
        <h4 class="card-title">{{ title }}</h4>
        <p class="card-category" v-if="subTitle">{{ subTitle }}</p>
      </slot>
    </div>
    <div class="card-body" v-if="$slots.default" :class="bodyClasses">
      <slot></slot>
    </div>
    <div class="card-image" v-if="$slots['image-bottom']">
      <slot name="image-bottom"></slot>
    </div>
    <!-- <div class="card-icon">
      <slot name="icon-left">
        <div class="row">
          <div class="col-lg">
            <img :src="icon" width="40px" />
          </div>
          <div class="col-lg text-right" style="">
            <p class="card-category" style="font-size: 10px; color:#6A6A73">{{ secondtitle }}</p>
          
            <h4 class="card-title" style="font-size: 15px;">{{ mainTitle }}</h4>
          </div>
        </div>
      </slot>
      <div class="row bottom-line" v-if="noderssi != ''">
        <div class="col-lg">
          <p>Node RSSI</p>
        </div>
        <div class="col-lg-5 bottom-line" style="color:#ffffff">: {{ noderssi }}</div>
      </div>
      <div class="row bottom-line"  v-if="gatewayrssi != ''">
        <div class="col-lg">
          <p>Gateway RSSI</p>
        </div>
        <div class="col-lg-5" style="color:#ffffff">: {{ gatewayrssi }}</div>
      </div>
      <div class="row bottom-line"  v-if="value != ''" style="padding-top: 12px">
        <div class="col-lg ">
          <p>Value (lx)</p>
        </div>
        <div class="col-lg-5" style="color:#ffffff">: {{ value }}</div>
      </div>
    </div> -->
    <slot name="raw-content"></slot>
    <div class="card-footer" :class="footerClasses" v-if="$slots.footer">
      <hr v-if="showFooterLine" />
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "card",
  props: {
    title: {
      type: String,
      description: "Card title",
    },
    subTitle: {
      type: String,
      description: "Card subtitle",
    },
    type: {
      type: String,
      description: "Card type (e.g primary/danger etc)",
    },
    showFooterLine: {
      type: Boolean,
      default: false,
    },
    headerClasses: {
      type: [String, Object, Array],
      description: "Card header css classes",
    },
    bodyClasses: {
      type: [String, Object, Array],
      description: "Card body css classes",
    },
    footerClasses: {
      type: [String, Object, Array],
      description: "Card footer css classes",
    },
    icon: {
      type: [String, Object, Array],
      description: "Card footer css classes",
    },
    noderssi: {
      type: [String, Object, Array],
      description: "Card footer css classes",
    },
    gatewayrssi: {
      type: [String, Object, Array],
      description: "Card footer css classes",
    },
    mainTitle: {
      type: [String, Object, Array],
      description: "Card footer css classes",
    },
    secondtitle: {
      type: [String, Object, Array],
      description: "Card footer css classes",
    },
    value: {
      type: [String, Object, Array],
      description: "Card footer css classes",
    },
  },
  watch:{
    noderssi(){
    
    }
  }
};
</script>
<style>
.bottom-line {
  font-size: 9px;
}

</style>
